export class AwsVaultConfigInput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "encryptionKey",
            "baseName": "encryptionKey",
            "type": "string",
            "format": ""
        },
        {
            "name": "mrapAlias",
            "baseName": "mrapAlias",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AwsVaultConfigInput.attributeTypeMap;
    }
    constructor() {
    }
}
